"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PossibleStorages = void 0;
const Oidc = __importStar(require("oidc-client"));
const auth_ntp_1 = __importDefault(require("./auth.ntp"));
const env_1 = require("./utils/env");
const AUTH_DOMAIN_STG = `${env_1.SSO_DOMAINS.SSO_STAGING}/oidc`;
const AUTH_DOMAIN_PROD = `${env_1.SSO_DOMAINS.SSO_PRODUCTION}/oidc`;
const APP_AUTH_ROUTE = `${window.location.origin}/auth`;
const SILENT_REQUEST_MIN_TIMEOUT = 2000;
const SILENT_REQUEST_DEFAULT_TIMEOUT = 5000;
// Fix authorities when there is only one role and backend returns a string
const fixAuthorities = (user) => {
    var _a, _b;
    if (!user)
        return user;
    //deep clone object
    const userCopy = JSON.parse(JSON.stringify(user));
    const authorities = (_b = (_a = userCopy === null || userCopy === void 0 ? void 0 : userCopy.profile) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.authorities;
    if (authorities && typeof authorities === 'string') {
        userCopy.profile.attributes.authorities = [authorities];
        userCopy.profile.authorities = [authorities];
    }
    user.profile = userCopy.profile;
    return user;
};
var PossibleStorages;
(function (PossibleStorages) {
    PossibleStorages["localStorage"] = "localStorage";
    PossibleStorages["inMemoryStorage"] = "inMemoryStorage";
    PossibleStorages["sessionStorage"] = "sessionStorage";
    PossibleStorages["default"] = "localStorage";
})(PossibleStorages = exports.PossibleStorages || (exports.PossibleStorages = {}));
class AuthServiceDefault {
    constructor(instanceParam) {
        this.isProd = env_1.isProd;
        let settings = {};
        let silentRequestTimeout = SILENT_REQUEST_DEFAULT_TIMEOUT;
        this.isSigninSilentByRedirect = false;
        if (typeof instanceParam === 'string') {
            settings['client_id'] = instanceParam;
        }
        else if (instanceParam) {
            settings = instanceParam;
        }
        if (!settings['client_id']) {
            throw Error('Please provide a client id');
        }
        if (settings.env) {
            this.isProd = settings.env === 'production';
        }
        if (settings.silentRequestTimeout) {
            silentRequestTimeout = Math.max(settings.silentRequestTimeout, SILENT_REQUEST_MIN_TIMEOUT);
        }
        const defaultSetting = {
            authority: this.isProd ? AUTH_DOMAIN_PROD : AUTH_DOMAIN_STG,
            redirect_uri: `${APP_AUTH_ROUTE}/login`,
            popup_redirect_uri: `${APP_AUTH_ROUTE}/login`,
            silent_redirect_uri: `${APP_AUTH_ROUTE}/renew`,
            post_logout_redirect_uri: `${APP_AUTH_ROUTE}/logout`,
            popup_post_logout_redirect_uri: `${APP_AUTH_ROUTE}/logout`,
            automaticSilentRenew: true,
            revokeAccessTokenOnSignout: true,
            scope: 'openid profile',
            response_type: 'code',
            popupWindowFeatures: 'location=no,toolbar=no,width=500,height=659,left=100,top=100',
            popupWindowTarget: 'cas-popup-window',
            clockService: new auth_ntp_1.default(this.isProd)
        };
        this.userManager = new Oidc.UserManager(Object.assign(Object.assign(Object.assign({}, defaultSetting), settings), { silentRequestTimeout, userStore: this.getStorage(settings.storeToUse), stateStore: this.getStorage(settings.storeToUse) }));
        Oidc.Log.logger = console;
    }
    getStorage(storage) {
        const Storages = {
            localStorage: () => localStorage,
            sessionStorage: () => sessionStorage,
            inMemoryStorage: () => new Oidc.InMemoryWebStorage()
        };
        const store = Storages[storage !== null && storage !== void 0 ? storage : 'localStorage']();
        return new Oidc.WebStorageStateStore({ store });
    }
    // User methods
    getUser() {
        return this.userManager.getUser().then((response) => fixAuthorities(response));
    }
    removeUser() {
        return this.userManager.removeUser();
    }
    // SignIn methods
    signinRedirect(...args) {
        return this.userManager.signinRedirect(...args);
    }
    signinPopup(...args) {
        return this.userManager.signinPopup(...args);
    }
    signinSilent(...args) {
        return this.userManager.signinSilent(...args);
    }
    signinCallback(...args) {
        let signInResponse;
        return this.userManager.signinCallback(...args).then((response) => {
            signInResponse = response;
            return this.userManager.clearStaleState();
        }).then(() => fixAuthorities(signInResponse));
    }
    signinSilentCallback(...args) {
        return this.userManager.signinSilentCallback(...args);
    }
    // SignOut methods
    signoutRedirect(...args) {
        return this.userManager.signoutRedirect(...args);
    }
    signoutPopup(...args) {
        return this.userManager.signoutPopup(...args);
    }
    signoutCallback(...args) {
        let signOutResponse;
        return this.userManager.signoutCallback(...args).then((response) => {
            signOutResponse = response;
            return this.userManager.clearStaleState();
        }).then(() => {
            return signOutResponse;
        });
    }
    /**
     * @description Defines whether the current sign-out is silent or not by identifying the
     * 'silent' param on the sign-out callback URL.
     * @returns {boolean} **TRUE** for silent or **FALSE** for no silent (sign-out redirect).
     */
    isSignoutSilent() {
        return new URLSearchParams(window.location.search).get('silent') === 'true';
    }
    /**
     * @description The callback notification for the sign-out silent.
     * It's used to notify the parent window when the sign-out process is over.
     * More details about how it works can be found on OIDC IFrameNavigator class.
     * @param {string} url The sign-out url (optional param).
     * @returns Returns a promise to notify the parent window of response from the end session endpoint.
     */
    signoutSilentCallback(url = window.location.href) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.userManager._iframeNavigator.callback(url);
            }
            catch (error) {
                console.error({ origin: '[CAS signoutSilentCallback]', error });
            }
        });
    }
    /**
     * @description Logs out the current user silently (without redirect).
     * @param {SignoutRequestArgs} args The targeted id_token_hint to be logged out.
     */
    signoutSilent(args = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.userManager._signout({
                    request_type: 'so:s',
                    post_logout_redirect_uri: `${APP_AUTH_ROUTE}/logout?silent=true`,
                    id_token_hint: args.id_token_hint,
                }, this.userManager._iframeNavigator, { silentRequestTimeout: this.userManager.settings.silentRequestTimeout });
            }
            catch (error) {
                console.error({ origin: '[CAS signoutSilent]', error });
            }
        });
    }
    /**
     * @description Retrieves the authority endpoint used on `authService` initialization.
     * @returns The current authority endpoint.
     */
    getAuthority() {
        return this.userManager.settings.authority;
    }
}
class AuthServiceCustomDomain extends AuthServiceDefault {
    signinRedirect() {
        return this.userManager.signinRedirect(Object.assign({}, (this.isSigninSilentByRedirect && { extraQueryParams: { checkLogin: true } })));
    }
    signinSilent() {
        return this.signinRedirect();
    }
    signinCallback(args) {
        const error = new URL(location.href).searchParams.get('error');
        return error ? Promise.resolve(error) : super.signinCallback(args);
    }
}
const AuthService = class AuthService {
    constructor(instanceParam) {
        const AuthServiceClass = env_1.isCustomDomain ? AuthServiceCustomDomain : AuthServiceDefault;
        return new AuthServiceClass(instanceParam);
    }
};
exports.default = AuthService;
